import {
  IconButton,
  Card as MuiCard,
  CardContent as MuiCardContent,
  CardHeader as MuiCardHeader,
  styled,
} from "@mui/material";

import { dontForwardProps } from "@/lib/styled";

export const Card = styled(MuiCard, {
  shouldForwardProp: dontForwardProps("isFullscreen"),
})<{ isFullscreen?: boolean }>(({ isFullscreen }) => ({
  containerType: "size",
  containerName: "widget",
  boxShadow: "0px 4px 20px 8px rgba(0, 0, 0, 0.05)",
  borderRadius: "8px",
  display: "flex",
  flexDirection: "column",
  transition: "none",

  "@media print": {
    boxShadow: "none",
    position: "relative",
    width: "auto",
    height: "auto",
  },

  // Fix these important statements
  "@media (max-width: 800px)": isFullscreen
    ? {
        left: "8px !important",
        top: "180px !important",
        width: "calc(100vw - 16px) !important",
        height: "calc(100vh - 188px) !important",
      }
    : undefined,
}));

export const CardHeader = styled(MuiCardHeader)(({ theme }) => ({
  padding: theme.spacing(1.5, 2.5),

  "@media print": {
    paddingInline: "0",
    overflow: "visible",
  },
}));

export const CardContent = styled(MuiCardContent)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  flexGrow: 1,
  padding: theme.spacing(0, 2.5),
  width: "100%",
  overflow: "hidden",
  overflowY: "auto",

  "@media print": {
    paddingInline: "0",
    overflow: "visible",
  },
}));

export const FullScreenWrapper = styled("div")(({ theme }) => ({
  position: "fixed",
  inset: 0,
  backgroundColor: "white",
  display: "flex",
  flexFlow: "column",
  alignItems: "center",
  overflow: "hidden",
  zIndex: 999,
  padding: theme.spacing(5),
}));

export const FullScreenWidgetContainer = styled("div")({
  alignItems: "stretch",
  display: "flex",
  justifyContent: "flex-start",
  flex: "1 1 auto",
  flexDirection: "column",
  overflow: "hidden",
  overflowY: "auto",
  width: "100%",
});

export const FullScreenTitleContainer = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
  marginBottom: theme.spacing(2),
}));

export const FullScreenButton = styled(IconButton)`
  @media print {
    display: none;
  }
`;
